import HttpError from './HttpError.component';

export default HttpError;
